import { Flex, Heading, Img, Show, Stack } from "@chakra-ui/react";
import { VideoPlayer } from "../components/VideoPlayer";

import { images } from "../media/images";

export const Gallery = () => {
	return (
		<Stack
			id="gallery"
			gap="4"
			pt={{ base: "6", md: "0" }}
			pb={{ base: "2", md: "0" }}
			overflow="hidden"
		>
			<Show below="md">
				<VideoPlayer />
			</Show>

			<Heading textAlign="left" fontSize="lg" px={{ base: "4", md: "8" }}>
				EXPLORE MY BODY... (OF WORK)
			</Heading>

			<Flex
				h="xs"
				overflowX="scroll"
				css={{
					"&::-webkit-scrollbar": {
						height: 0,
						background: "transparent",
					},
				}}
			>
				{images.map((image, index) => (
					<Img
						mr={{ base: "4", md: "8" }}
						h="auto"
						rounded="3"
						src={image}
						key={image}
						objectFit="cover"
						ml={index === 0 ? { base: "4", md: "8" } : "auto"}
						onContextMenu={(e) => e.preventDefault()}
					/>
				))}
			</Flex>
		</Stack>
	);
};
